import { api } from '@goaltree/backend/convex/_generated/api'
import { cn } from '@goaltree/ui/lib/utils'
import { useQuery } from 'convex/react'
import { PencilLine } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// "Edited by your coach Sam" on a node the client's coach changed. The coach viewing
// their client's plan sees "You edited" instead.
export function CoachEditedTag({
  by,
  viewerIsCoach,
  className,
}: {
  by: string
  viewerIsCoach?: boolean
  className?: string
}) {
  const { t } = useTranslation()
  const coach = useQuery(api.coaching.myCoach, viewerIsCoach ? 'skip' : {})
  const label = viewerIsCoach
    ? t('coaching.youEdited')
    : coach?.coachId === by
      ? t('coaching.editedBy', { name: coach.coach.name })
      : t('coaching.editedByCoach')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 font-mono text-[11px]',
        viewerIsCoach ? 'text-primary-text/80' : 'text-coach-text',
        className,
      )}
    >
      <PencilLine className="size-3 shrink-0" />
      {label}
    </span>
  )
}
